import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { SectionTitle } from './ui/Section';
export function Testimonials() {
  return <section className="bg-slate-50 px-4 py-12 md:py-16" data-id="element-235" data-mp="3fze3dwmz31v5">
      <div className="mx-auto max-w-6xl" data-id="element-236" data-mp="3fxumc3thsmsb">
        <SectionTitle data-id="element-237" data-mp="3b0udjl59d5xi">Professionals using the system</SectionTitle>

        <div className="mt-8 grid gap-5 md:grid-cols-2 lg:grid-cols-6" data-id="element-238" data-mp="3ayhypgusrboo">
          {testimonials.map((item, index) => <figure key={item.name} className={`flex flex-col rounded-2xl border border-blue-950/10 bg-white p-6 shadow-sm lg:col-span-2 ${index === 3 ? 'lg:col-start-2' : ''}`} data-id="element-239" data-mp="31zwab52n92fz" data-mpi={index}>
              <div className="flex gap-0.5" role="img" aria-label="5 out of 5 stars" data-id="element-240" data-mp="2s28h4jkos2zx">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" aria-hidden="true" data-id="element-241" data-mp="v8nad69yidgi" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-blue-950" data-id="element-242" data-mp="h5ezbmd4bx17">“{item.quote}”</blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-blue-950/10 pt-4" data-id="element-243" data-mp="m62p64pm27tu">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blue-700 text-xs font-black text-white" data-id="element-244" data-mp="78tt4xpd4fvs">
                  {item.initials}
                </span>
                <span data-id="element-245" data-mp="zxhaii6zql42">
                  <span className="block text-sm font-extrabold uppercase text-blue-950" data-id="element-246" data-mp="zwxzllfrcwzj">{item.name}</span>
                  <span className="block text-xs text-slate-600" data-id="element-247" data-mp="14ur50c98lmyr">{item.role}</span>
                </span>
              </figcaption>
            </figure>)}
        </div>
        <p className="mt-6 text-center text-xs text-slate-600" data-id="element-248" data-mp="v4enkswpy9wu">Individual experiences may vary.</p>
      </div>
    </section>;
}